export interface DocsAnnouncement {
  /** Changes with the message, so people who closed the last one see this one. */
  id: string;
  text: string;
  linkLabel: string;
  /** An in-app route. */
  link: string;
}

/** The bar across the top of the docs; null hides it. Keep it to things
 *  that are true today: it's the first line every docs reader sees. */
export const DOCS_ANNOUNCEMENT: DocsAnnouncement | null = {
  id: '2026-10-playground-all',
  text: 'Try every endpoint live in the Playground, with your own API key.',
  linkLabel: 'Open the Playground',
  link: '/playground',
};
